import { Decimal } from 'decimal.js';

/** Trim long ledger decimals for wallet 资产概况 cells. */
export function formatWalletBalance(raw: string | null | undefined): string {
  if (raw == null || raw === '') return '0';
  const trimmed = raw.trim();
  if (!trimmed) return '0';
  try {
    const d = new Decimal(trimmed);
    if (d.isZero()) return '0';
    const fixed = d.toDecimalPlaces(4, Decimal.ROUND_DOWN).toFixed();
    return fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  } catch {
    return trimmed;
  }
}
